import { createContext } from 'react';
const SourceContext = createContext();
export default SourceContext;
